'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512c-282.77 0-512 229.23-512 512s229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416c-229.75 0-416-186.25-416-416s186.25-416 416-416z' }),
        React.createElement('path', { d: 'M480 256l-256 256 256 256 96-96-96-96h288v-128h-288l96-96z' })
    ));
};